(function (angular) {
	'use strict';

	angular.module('questionnaireModule', [
		'coreModule',
		'localStorageModule',
		'ngCookies'
	]);
})(window.angular);